import { render, staticRenderFns } from "./WDataSelectAutocomplete.vue?vue&type=template&id=1efb993a&"
import script from "./WDataSelectAutocomplete.vue?vue&type=script&lang=js&"
export * from "./WDataSelectAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports